import React, { useEffect } from "react";
import { Header } from "../../Components/Header/Header";
import { assertFbSdkDidNotCacheTokens } from "../../utils/fbSdkAssertions";
import "./button.css";

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}

interface Props {
  title: string;
  configId: string;
  onCode: (code: string) => void;
}

const FacebookConnectPage: React.FC<Props> = ({ title, configId, onCode }) => {
  const APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID!;
  const API_VERSION = process.env.REACT_APP_FACEBOOK_API_VERSION!;

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: APP_ID,
        cookie: false,
        localStorage: false,
        xfbml: true,
        version: API_VERSION,
      });
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    document.body.appendChild(script);
  }, [API_VERSION, APP_ID]);

  const handleFBLogin = () => {
    window.FB.login(
      (response: any) => {
        assertFbSdkDidNotCacheTokens(APP_ID);
        if (response.authResponse?.code) {
          onCode(response.authResponse.code);
        } else {
          console.error("Login failed or no code received.");
        }
      },
      {
        config_id: configId,
        response_type: "code",
        override_default_response_type: true,
      },
    );
  };

  return (
    <div className="account-pages container-login100">
      <div className="container">
        <Header />
        <div className="row justify-content-center mb-4">
          <div className="col-sm-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card fb-title">
              <div className="card-body text-center">
                <div className="card-block">
                  <h1 className="card-title mt-3 mb-0">{title}</h1>
                  <div
                    className="fb-button mt-4"
                    style={{ marginLeft: "100px" }}>
                    <button className="fb-login-button" onClick={handleFBLogin}>
                      <div className="icon-circle">
                        <span className="fab fa-facebook-f"></span>
                      </div>
                      Login with Facebook
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacebookConnectPage;
